<template>
  <div class="md-layout" v-if="everythingLoaded">
    <drivers-periods-unavailable-type-overview
      v-for="unavailablePeriodType in unavailablePeriodTypes"
      :key="unavailablePeriodType['id']"
      class="md-layout-item md-medium-size-100"
      :periods="computeTableData(unavailablePeriodType['id'])"
      :periodType="unavailablePeriodType"
      :loaded="everythingLoaded"
    >
    </drivers-periods-unavailable-type-overview>
  </div>
</template>

<script>
import DriversPeriodsUnavailableTypeOverview from "@/pages/Dashboard/Drivers/DriversPeriodsUnavailableTypeOverview";

export default {
  components: {
    DriversPeriodsUnavailableTypeOverview
  },
  computed: {
    everythingLoaded: function() {
      for (let i in this.loaded) {
        if (!this.loaded[i]) {
          return false;
        }
      }

      return true;
    }
  },
  data() {
    return {
      currentSort: "label",
      currentSortOrder: "asc",
      loaded: {
        unavailablePeriods: false,
        unavailablePeriodTypes: false
      },
      pagination: {
        perPage: 200,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100, 200, 500],
        total: 0
      },
      unavailablePeriods: [],
      unavailablePeriodTypes: [],
      footerTable: ["Label", "Start datum", "Stop datum"],
      searchQuery: "",
      propsToSearch: ["label", "startDate", "stopDate"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      addButtonDisabled: true
    };
  },
  methods: {
    loadUnavailablePeriods() {
      this.addButtonDisabled = true;
      this.$http
        .get(
          this.$apiBaseUrl +
            "drivers/" +
            this.$route.params.id +
            "/unavailableperiods"
        )
        .then(
          response => {
            this.unavailablePeriods = response.data.unavailablePeriods;
            this.loaded.unavailablePeriods = true;
          },
          response => {
            if (response.status === 403) {
              this.addButtonDisabled = false;
              this.notifyVue(
                "U heeft geen rechten voor het beheren van Chauffeur afwezigheid",
                "add_alert",
                "danger",
                0
              );
            }

            return [];
          }
        );
    },
    loadUnavailablePeriodTypes() {
      this.addButtonDisabled = true;
      this.$http
        .get(this.$apiBaseUrl + "drivers/unavailableperiods/types")
        .then(
          response => {
            this.unavailablePeriodTypes = response.data.unavailablePeriodTypes;
            this.loaded.unavailablePeriodTypes = true;
          },
          response => {
            if (response.status === 403) {
              this.addButtonDisabled = false;
              this.notifyVue(
                "U heeft geen rechten voor het beheren van Chauffeur niet-beschikbare perioden",
                "add_alert",
                "danger",
                0
              );
            }

            return [];
          }
        );
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    computeTableData(typeId) {
      if (!this.everythingLoaded) {
        return [];
      }

      let data = [];
      for (let i in this.unavailablePeriods) {
        if (this.unavailablePeriods[i]["type_id"] !== typeId) {
          continue;
        }
        data.push(this.unavailablePeriods[i]);
      }

      return data;
    }
  },
  mounted() {
    this.loadUnavailablePeriods();
    this.loadUnavailablePeriodTypes();
  }
};
</script>

<style lang="css"></style>
